if (!customElements.get('countdown-timer')){
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.duration = this.hasAttribute('timer-duration') ? parseInt(this.getAttribute('timer-duration'), 10) : 0;
      this.endDate = this.getEndDate();
      this.save_state = this.getAttribute('timer-save-state') === 'true';
      this.on_finish = this.hasAttribute('timer-on-finish') ? this.getAttribute('timer-on-finish') : undefined;
      this.block_id = this.hasAttribute('timer-id') ? this.getAttribute('timer-id') : undefined;
      this.originalText = this.innerText;
      this.timer = null;
      this.completed = false;

      if (!this.block_id) {
        console.debug('Timer block ID is missing');
        return;
      }

      if (this.endDate !== null) {
        this.updateDurationFromEndDate();
      }
      this.render();

      const savedState = this.getSavedState();
      if (this.endDate === null && savedState && Number.isFinite(savedState.duration)) {
        this.duration = savedState.duration;
        this.render();
      }
    }

    connectedCallback() {
      if (!this.block_id) {
        console.debug('Timer block ID is missing');
        return;
      }
      this.start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    getEndDate() {
      const value = this.getAttribute('timer-end-date');
      if (!value) return null;

      const timestamp = Date.parse(value);
      return Number.isNaN(timestamp) ? null : timestamp;
    }

    updateDurationFromEndDate() {
      this.duration = Math.max(0, Math.ceil((this.endDate - Date.now()) / 1000));
    }

    start() {
      clearInterval(this.timer);
      this.completed = false;

      const tick = () => {
        if (this.endDate !== null) {
          this.updateDurationFromEndDate();
        } else {
          this.duration--;
        }

        if (this.duration <= 0) {
          this.duration = 0;
          this.render();
          clearInterval(this.timer);
          this.clearState();
          this.onComplete();
          return;
        }

        this.saveState();
        this.render();
      };

      if (this.endDate !== null) {
        tick();
      }

      if (!this.completed && this.duration > 0) {
        this.timer = setInterval(tick, 1000);
      }
    }

    getSavedState() {
      if (!this.save_state || this.endDate !== null) return null;

      try {
        const state = JSON.parse(localStorage.getItem('countdownState') || '{}');
        return state[this.block_id] || null;
      } catch (error) {
        localStorage.removeItem('countdownState');
        return null;
      }
    }

    saveState() {
      if (!this.save_state || this.endDate !== null) return;

      let state = {};
      try {
        state = JSON.parse(localStorage.getItem('countdownState') || '{}');
      } catch (error) {
        state = {};
      }

      state[this.block_id] = { duration: this.duration };
      localStorage.setItem('countdownState', JSON.stringify(state));
    }

    clearState() {
      if (!this.save_state) return;

      try {
        const state = JSON.parse(localStorage.getItem('countdownState') || '{}');
        delete state[this.block_id];
        if (Object.keys(state).length) {
          localStorage.setItem('countdownState', JSON.stringify(state));
        } else {
          localStorage.removeItem('countdownState');
        }
      } catch (error) {
        localStorage.removeItem('countdownState');
      }
    }

    render() {
      const days = Math.floor(this.duration / (24 * 60 * 60));
      const hours = Math.floor((this.duration % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((this.duration % (60 * 60)) / 60);
      const seconds = Math.floor(this.duration % 60);

      this.querySelectorAll('span').forEach((span) => {
        switch (span.className) {
          case 'countdown-timer-days':
            span.innerText = days > 9 ? days : `0${days}`;
            break;
          case 'countdown-timer-hours':
            span.innerText = hours > 9 ? hours : `0${hours}`;
            break;
          case 'countdown-timer-minutes':
            span.innerText = minutes > 9 ? minutes : `0${minutes}`;
            break;
          case 'countdown-timer-seconds':
            span.innerText = seconds > 9 ? seconds : `0${seconds}`;
            break;
        }
      });
    }

    onComplete() {
      if (this.completed) return;
      this.completed = true;

      if (this.on_finish) {
        this.setText(this.on_finish);
      } else if (this.endDate === null) {
        this.duration = this.hasAttribute('timer-duration') ? parseInt(this.getAttribute('timer-duration'), 10) : 0;
        this.start();
      }
    }

    setText(text) {
      this.innerText = text;
      this.clearState();
    }
  });
}
